import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { pie } from 'd3-shape';
import { useEffect, useState } from 'react';
import { View } from 'react-native';
import { G, Svg } from 'react-native-svg';
import { BLACK_800, BLACK_900 } from '../../../constants';
import { Typography } from '../../typography/Typography';
import { getDonutChartStyles } from '../DonutGraphStyles';
import { formatNumber, getTotalSum } from './DonutChartUtils';
import { PieSlice } from './DonutSlice';
export var Pie = props => {
  var value = props.value,
    data = props.data,
    size = props.size,
    pieSize = props.pieSize,
    onItemSelected = props.onItemSelected,
    showBigNumber = props.showBigNumber,
    _props$productName = props.productName,
    productName = _props$productName === void 0 ? '' : _props$productName;
  var donutChartStyles = getDonutChartStyles();
  var _useState = useState(null),
    arcs = _useState[0],
    setArcs = _useState[1];
  var _useState2 = useState(0),
    bigNumber = _useState2[0],
    setBigNumber = _useState2[1];
  useEffect(() => {
    var calculatedArcs = pie().value(item => item.number)(data);
    setArcs(calculatedArcs);
    var calculatedSum = getTotalSum(data);
    setBigNumber(calculatedSum);
  }, [data, pieSize]);
  return arcs && (data === null || data === void 0 ? void 0 : data.length) === (arcs === null || arcs === void 0 ? void 0 : arcs.length) ? _jsxs(View, Object.assign({
    style: donutChartStyles.donutChartContainer
  }, {
    children: [_jsx(Svg, Object.assign({
      width: size,
      height: size,
      viewBox: "0 0 " + size + " " + size
    }, {
      children: _jsx(G, Object.assign({
        transform: "translate(100, 100)"
      }, {
        children: data === null || data === void 0 ? void 0 : data.map((_ref, index) => {
          var color = _ref.color;
          return _jsx(PieSlice, {
            color: color,
            onSelected: onItemSelected(index),
            arcData: arcs[index],
            isActive: value.index === index
          }, "pie_shape_" + index);
        })
      }))
    })), showBigNumber && _jsxs(View, Object.assign({
      style: donutChartStyles.donutChartItem
    }, {
      children: [_jsx(Typography, {
        text: formatNumber(bigNumber),
        type: "body-single-line-md-bold",
        color: BLACK_900
      }), _jsx(Typography, {
        numberOfLines: 2,
        textAlignment: "center",
        text: productName,
        type: "body-para-sm",
        color: BLACK_800
      })]
    }))]
  })) : null;
};